// extracted by mini-css-extract-plugin
var _1 = "BuildingField-modulebuildingFieldTags__YFzEQ FormFieldSelectNG-moduleformFieldMultiSelectTags__U0s9Y SelectValueTags-moduleSelectValueTags__hO7SX TagBar-moduleTagBar__a7w7V";
export { _1 as "buildingFieldTags" }
